/**
 * Select memoizzato con ricerca
 * @module flyers/components/fields/MemoizedSelectField
 */

import React from "react";
import { Select } from "antd";
import FloatingField from "@shared/components/FloatingField.jsx";

/**
 * Campo select ottimizzato con ricerca
 */
const MemoizedSelectField = React.memo(({
    fieldKey,
    label,
    value,
    options,
    onChange,
    disabled,
    loading,
    filterOption,
    notFoundContent
}) => {
    const handleChange = React.useCallback((optionValue) => {
        onChange(fieldKey, optionValue || null);
    }, [fieldKey, onChange]);

    return (
        <FloatingField label={label}>
            <Select
                placeholder={label}
                showSearch
                allowClear
                options={options}
                value={value ? String(value) : undefined}
                filterOption={filterOption}
                onChange={handleChange}
                loading={loading}
                notFoundContent={notFoundContent}
                disabled={disabled}
            />
        </FloatingField>
    );
}, (prevProps, nextProps) => {
    return (
        prevProps.value === nextProps.value &&
        prevProps.disabled === nextProps.disabled &&
        prevProps.loading === nextProps.loading &&
        prevProps.options === nextProps.options &&
        prevProps.fieldKey === nextProps.fieldKey
    );
});

MemoizedSelectField.displayName = "MemoizedSelectField";

export default MemoizedSelectField;
